import P from "prop-types";
import { useState } from "react";

import { Apresentacao } from "./Apresentacao";
import { GraficosSession } from "./GraficosSession";
import { InfoText } from "./InfoText";

import * as Styles from "./styles";

export default function PainelSentimentos({ hidden }) {
  const [query, setQuery] = useState("all")

  if (hidden) {
    return <></>;
  } else {
    return (
      <Styles.Container>
       <Apresentacao queryState={query} setState={setQuery}/>
       <InfoText/>
       <GraficosSession queryState={query}/>
      </Styles.Container>
    );
  }
}
PainelSentimentos.propTypes = {
  hidden: P.bool.isRequired,
};
